import { ReactNode } from 'react';

import { useDraggable } from '@dnd-kit/core';

import { DonorInfo } from '@/app/services/fertWork';

export type DraggableDonorProps = {
  donor: DonorInfo;
  sourceRunId: string | null;
  children: ReactNode;
  dataTour?: string;
};

export const DraggableDonor = ({
  donor,
  sourceRunId,
  children,
  dataTour,
}: DraggableDonorProps) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `donor-${donor.id}-${sourceRunId || 'unassigned'}`,
    data: { donor, sourceRunId },
  });

  return (
    <div
      ref={setNodeRef}
      className={`group inline-flex items-stretch ${isDragging ? 'opacity-50' : ''}`}
    >
      <div
        {...listeners}
        {...attributes}
        data-tour={dataTour}
        className="flex w-5 flex-shrink-0 cursor-grab touch-none items-center justify-center rounded-l border border-r-0 border-gray-200 bg-gray-50 transition-colors hover:bg-gray-100 active:bg-gray-200"
      >
        <div className="flex flex-col gap-[2px]">
          <div className="flex gap-[2px]">
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
          </div>
          <div className="flex gap-[2px]">
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
          </div>
          <div className="flex gap-[2px]">
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
            <div className="h-[3px] w-[3px] rounded-full bg-gray-400" />
          </div>
        </div>
      </div>
      <div className="[&>div]:rounded-l-none [&>div]:border-l-0">
        {children}
      </div>
    </div>
  );
};
